import { Dispatch, ThunkAction } from '../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../types/types';
import { updateBoardName } from 'app/rest/effects/board/updateBoardName';
import { ESegmentClickType, ESegmentClickTypeEventOption } from '../../../../../../../middlewares/segment/constants';
import { SegmentBoardEvent, segmentTrackAction } from '../../../../../../../middlewares/segment';

export const onNameChanged = (
    boardId: TBoardId,
    name: string,
    clickType: ESegmentClickType
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentBoardEvent.NAVIGATION_PANEL_BOARD_RENAMED, {
            name: ESegmentClickTypeEventOption.CLICK_TYPE,
            value: clickType
        }));
        return dispatch(updateBoardName(boardId, name));
    };
    return action;
};
